import styled from 'styled-components';
import media from '../../../styles/media';
import Link from 'next/link';

export const TechnologyWrapper = styled(Link)<{ columnNumber?: number; tiny?: boolean }>`
  width: calc(50% - 20px);
  margin: ${(props) => (props.tiny ? '0' : 'auto')};
  margin-bottom: ${(props) => (props.tiny ? '4px' : '60px')};
  text-align: center;
  min-width: ${(props) => (props.tiny ? '60px' : '115px')};
  cursor: pointer;
  ${media('medium')} {
    width: ${(props) =>
      props.columnNumber ? `calc(${100 / props.columnNumber}% - 20px)` : 'calc(25% - 20px)'};
  }
  &:hover {
    text-decoration: underline;
    > div > div:first-child {
      transform: translateY(-5px);
      box-shadow: 1px 1px 5px 0px #aaa;
    }
  }
  > div {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    h3 {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      width: 100%;
      font-size: ${(props) => (props.tiny ? '11px' : undefined)};
    }
    > div:first-child {
      background: white;
      height: ${(props) => (props.tiny ? '44px' : `${Math.round(70 * Math.sqrt(2) * 1.1)}px`)};
      width: ${(props) => (props.tiny ? '44px' : `${Math.round(70 * Math.sqrt(2) * 1.1)}px`)};
      transition: all 0.1s ease-in-out;
      overflow: visible;
      box-shadow: 1px 1px 4px 0px #ccc;
      border-radius: 100%;
      padding: ${(props) => (props.tiny ? '10px' : '30px')};
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      .logo {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        object-fit: cover;
      }
    }
  }
`;
